__turbopack_context__.v({
  "container": "EmptyRecommendations-module-scss-module__MI6DLW__container",
  "text": "EmptyRecommendations-module-scss-module__MI6DLW__text",
});
